module.exports = __webpack_public_path__ + "img/reloj.70aaac1a.svg";